export default "__VITE_ASSET__eaB_LLWk__"